import {
    LOAD_BIDDER_BIDDING_UPCOMING_FAIL,
    LOAD_BIDDER_BIDDING_UPCOMING_REQUEST,
    LOAD_BIDDER_BIDDING_UPCOMING_SUCCESS,
} from './actions';
import { createSelector } from 'reselect';
import { fetchBidderBiddingUpcoming } from '@/redux/api/biddingInfo';
import { getAuthToken } from './user';
import { getDeployment } from './config';
import { GlobalState } from '../rootReducer';
import ms from 'ms';

const REDUX_STORE_TIME = ms('15m');

export type State = {
    loaded: number;
    loading: boolean;
};

export const DEFAULT_STATE = {
    loaded: 0,
    loading: false,
};

export default function reducer(state: State = DEFAULT_STATE, action: any = {}): State {
    let loaded: State['loaded'];
    let loading: State['loading'];

    switch (action.type) {
        case LOAD_BIDDER_BIDDING_UPCOMING_FAIL:
            return {
                ...state,
                loading: false,
            };
        case LOAD_BIDDER_BIDDING_UPCOMING_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case LOAD_BIDDER_BIDDING_UPCOMING_SUCCESS:
            loaded = action.meta.actionTime;
            loading = false;
            return {
                ...state,
                loaded,
                loading,
            };
        default:
            return state;
    }
}

/* SELECTORS */
const stateSelector = (state: GlobalState) => state.bidderBiddingInfoUpcoming;

const loadedSelector = createSelector(stateSelector, (state) => state.loaded);

const loadingSelector = createSelector(stateSelector, (state) => state.loading);

const shouldFetch = createSelector([loadedSelector, loadingSelector], (loaded, loading) => {
    const time = Date.now();
    const diff = time - loaded;
    if (diff < REDUX_STORE_TIME) {
        return false;
    }
    return !loading;
});

/* ACTION CREATORS */
const doFetch = async ({ dispatch, getState }) => {
    const state = getState();
    try {
        const authToken = getAuthToken(state);
        const deployment = getDeployment(state);
        dispatch({
            meta: { actionTime: Date.now() },
            type: LOAD_BIDDER_BIDDING_UPCOMING_REQUEST,
        });
        const response = await fetchBidderBiddingUpcoming({ authToken, deployment });
        dispatch({
            meta: { actionTime: Date.now() },
            payload: response.data,
            type: LOAD_BIDDER_BIDDING_UPCOMING_SUCCESS,
        });
    } catch (error) {
        dispatch({
            error: true,
            meta: { actionTime: Date.now() },
            payload: error,
            type: LOAD_BIDDER_BIDDING_UPCOMING_FAIL,
        });
    }
};

export const fetchUpcomingBidderBiddingIfNeeded = () => async (dispatch: Function, getState: Function) => {
    const state = getState();
    const authToken = getAuthToken(state);
    if (authToken && shouldFetch(state)) {
        return doFetch({ dispatch, getState });
    }
    return Promise.resolve({});
};
